export const sortByStringOrder = (a: string, b: string, locales: string[] = ["NL"]): number => {
  return new Intl.Collator(locales).compare(a, b);
};
